export const ATTACHMENT_STATUS_LABELS = {
  generated: "GENERADO",
  preloaded: "PRECARGADO",
  uploaded: "CARGADO",
  signed: "FIRMADO",
  error: "ERROR",
  failed: "FALLIDO",
};

export const NOTIFICATION_STAGE_LABELS = {
  stage_1: "ETAPA 1",
  stage_2: "ETAPA 2",
  stage_3: "ETAPA 3",
  stage_4: "ETAPA 4",
};

export const statusChipSx = (status) => {
  const map = {
    generated: { bg: "rgba(25,118,210,0.10)", color: "primary.main" },
    uploaded: { bg: "rgba(46,125,50,0.10)", color: "success.main" },
    preloaded: { bg: "rgba(0,0,0,0.06)", color: "text.primary" },
    signed: { bg: "rgba(131,12,196,0.10)", color: "#830cc4" },
    error: { bg: "rgba(211,47,47,0.10)", color: "error.main" },
    failed: { bg: "rgba(211,47,47,0.10)", color: "error.main" },
  };
  const v = map[status] || map.preloaded;
  return {
    height: 22,
    borderRadius: 999,
    bgcolor: v.bg,
    color: v.color,
    fontWeight: 900,
    "& .MuiChip-label": { px: 1, fontSize: 12 },
  };
};

export const notificationStatusChipSx = (status) => {
  if (status === "success") {
    return {
      height: 22,
      borderRadius: 999,
      bgcolor: "rgba(46,125,50,0.10)",
      color: "success.main",
      fontWeight: 900,
      "& .MuiChip-label": { px: 1, fontSize: 12 },
    };
  }

  return {
    height: 22,
    borderRadius: 999,
    bgcolor: "rgba(211,47,47,0.10)",
    color: "error.main",
    fontWeight: 900,
    "& .MuiChip-label": { px: 1, fontSize: 12 },
  };
};

export function getPausedLawyers(legalFile) {
  return (legalFile?.lawyers || []).filter((l) => l.updates_paused);
}

export function isLegalFileLocked(legalFile) {
  return getPausedLawyers(legalFile).length > 0;
}

export const LOCKED_LEGAL_FILE_MESSAGE =
  "El expediente tiene un abogado con actualizaciones pausadas. Solo se puede consultar.";

export function timeAgo(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const diff = Date.now() - d.getTime();
  const sec = Math.floor(diff / 1000);
  const min = Math.floor(sec / 60);
  const hr = Math.floor(min / 60);
  const day = Math.floor(hr / 24);

  if (sec < 60) return `hace ${sec}s`;
  if (min < 60) return `hace ${min}m`;
  if (hr < 24) return `hace ${hr}h`;
  return `hace ${day}d`;
}
